<template>
  <div>
    <div style="margin-bottom:20px;">
      <Input
        v-model="searchCont"
        placeholder="输入租户关键字"
        clearable
        style="width: 200px;"
        @keyup.enter.native="searchHandler"
      />
      <Button type="primary" size="default" @click="searchHandler" style=" margin-left :10px;">查询</Button>
      <Button
        type="error"
        size="default"
        @click="delData"
        style=" margin:4px 0 0 0; float:right;"
      >批量删除</Button>
      <Button
        type="primary"
        size="default"
        @click="newNustomer"
        style=" margin:4px 30px 0 0; float:right;"
      >新建</Button>
    </div>
    <Table
      border
      ref="selection"
      :columns="columns12"
      :data="data6"
      @on-selection-change="changeSelection"
    >
      <template slot-scope="{ row }" slot="name">
        <strong>{{ row.name }}</strong>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button type="primary" size="small" style="margin-right: 5px" @click="show(index)">编辑</Button>
        <Button type="error" size="small" @click="remove(index)">删除</Button>
      </template>
    </Table>
    <Page
      class="pageBox"
      style="margin-top: 30px;text-align: center"
      :total="pageTotal"
      :current="page"
      :page-size="limit"
      @on-change="changePage"
    />
    <div>
      <Modal v-model="modal3" @on-ok="ok" @on-cancel="cancel" footer-hide>
        <Card style="width:100%;margin-top:30px;">
          <Form :model="formLeft" label-position="left" :label-width="100" style="margin-top:30px;">
            <FormItem label="租户编号">
              <Input v-model="formLeft.cliNum" />
            </FormItem>
            <FormItem label="租户名称">
              <Input v-model="formLeft.cliName" />
            </FormItem>
            <FormItem label="电话">
              <Input v-model="formLeft.cliPhone" placeholder="请填写电话号或者手机号" />
            </FormItem>
            <FormItem label="联系人">
              <Input v-model="formLeft.cliContact" />
            </FormItem>
            <FormItem label="地址">
              <Input v-model="formLeft.cliAddress" />
            </FormItem>
            <FormItem>
              <Button type="primary" @click="handleSubmit('formLeft')">确认</Button>
              <!-- <Button @click="handleReset('formLeft')" style="margin-left: 8px">取消</Button> -->
            </FormItem>
          </Form>
        </Card>
      </Modal>
    </div>
    <div>
      <Modal v-model="modal1" width="360">
        <p slot="header" style="color:#f60;text-align:center">
          <Icon type="ios-information-circle"></Icon>
          <span>删除租户</span>
        </p>
        <div style="text-align:center">
          <p>是否要删除{{this.name}}</p>
        </div>
        <div slot="footer">
          <Button type="error" size="large" long :loading="modal_loading" @click="del">确认</Button>
        </div>
      </Modal>
    </div>
  </div>
</template>
<script>
import api from '@/api/api';
export default {
  data () {
    return {
      pageTotal: 10, // 数据总条数
      page: 1, // 页码
      limit: 10, // 每页显示条数
      searchTermList: [{ searchAttr: "", searchVal: "" }], // 搜索条件
      modal1: false,
      modal_loading: false,
      modal3: false,
      name: "",
      formLeft: {
        id: "",
        cliNum: "",
        cliName: "",
        cliPhone: "",
        cliContact: "",
        cliAddress: "",
        password: "123456",
        clientId: "",
        checkpassword: "123456",
        roleList: [{ roleName: 1 }],
        roleId: 0
      },
      id: "",
      searchCont: "",
      columns12: [
        // {
        //   title: "cliName",
        //   slot: "cliName"
        // },
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: "租户编号",
          key: "cliNum"
        },
        {
          title: "租户名称",
          key: "cliName"
        },
        {
          title: "电话",
          key: "cliPhone"
        },
        {
          title: "联系人",
          key: "cliContact"
        },
        {
          title: "地址",
          key: "cliAddress"
        },
        {
          title: "Action",
          slot: "action",
          width: 150,
          align: "center"
        }
      ],
      data6: [],
      selectionId: [], // 选中的id集合
      isSearchMore: true
    };
  },
  methods: {
    //编辑显示的页面
    show(index) {
      this.modal3 = true;
      this.formLeft.cliNum = this.data6[index].cliNum;
      this.formLeft.cliName = this.data6[index].cliName;
      this.formLeft.cliPhone = this.data6[index].cliPhone;
      this.formLeft.cliContact = this.data6[index].cliContact;
      this.formLeft.cliAddress = this.data6[index].cliAddress;
      this.formLeft.clientId = this.data6[index].id;
    },
    ok() {
      // this.$Message.info('取消编辑');
      this.handleSubmit();
    },
    handleSubmit() {
      let { cliNum, cliName, cliPhone, cliContact, cliAddress } = this.formLeft;
      if (!this.formLeft.cliName)
        return this.$Message.error("租户名称不能为空");
      if (!this.formLeft.cliNum) return this.$Message.error("租户编号不能为空");
      if (isNaN(this.formLeft.cliNum))
        return this.$Message.error("租户编号只能为数字");
      // if (!cliPhone) return this.$Message.error("电话不能为空");
      if (this.formLeft.cliPhone == "") {
        if (!this.formLeft.cliContact)
          return this.$Message.error("联系人不能为空");
        if (!this.formLeft.cliAddress)
          return this.$Message.error("地址不能为空");
        let params = Object.assign(
          {},
          {
            cliNum,
            cliName,
            cliPhone,
            cliContact,
            cliAddress
          }
        );
        let clientId = this.formLeft.clientId;
        if (clientId) {
          let id = clientId;
          api.updateClientById({ ...params, id }).then(res => {
            let data = res.data;
            if (data.code === 0) {
              this.$Message.success("更新成功");
              this.modal3 = false;
              // this.$router.back();
              this.getData();
            } else {
              this.$Message.error(data.msg);
            }
          });
        } else {
          api.newClient({ ...params }).then(res => {
            let data = res.data;
            if (data.code === 0) {
              this.$Message.success("添加成功");
              this.modal3 = false;
              // this.$router.back();
              this.getData();
            } else {
              this.$Message.error(data.msg);
            }
          });
        }
      } else {
        // if (!(/^1[34578]\d{9}$/.test(this.formLeft.cliPhone))) return this.$Message.error("请输入正确的电话");
        if (this.formLeft.cliPhone.length > "8") {
          if (!/^1[34578]\d{9}$/.test(this.formLeft.cliPhone))
            return this.$Message.error("请输入正确的电话或者手机号");
          // if (!(/^1[34578]\d{9}$/.test(this.formLeft.cliPhone))) return this.$Message.error("请输入正确的电话或者手机号");
          if (!this.formLeft.cliContact)
            return this.$Message.error("联系人不能为空");
          if (!this.formLeft.cliAddress)
            return this.$Message.error("地址不能为空");
          let params = Object.assign(
            {},
            {
              cliNum,
              cliName,
              cliPhone,
              cliContact,
              cliAddress
            }
          );
          let clientId = this.formLeft.clientId;
          if (clientId) {
            let id = clientId;
            api.updateClientById({ ...params, id }).then(res => {
              let data = res.data;
              if (data.code === 0) {
                this.$Message.success("更新成功");
                this.modal3 = false;
                // this.$router.back();
                this.getData();
              } else {
                this.$Message.error(data.msg);
              }
            });
          } else {
            api.newClient({ ...params }).then(res => {
              let data = res.data;
              if (data.code === 0) {
                this.$Message.success("添加成功");
                this.modal3 = false;
                // this.$router.back();
                this.getData();
              } else {
                this.$Message.error(data.msg);
              }
            });
          }
        } else {
          if (!/(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}/.test(this.formLeft.cliPhone))
            return this.$Message.error("请输入正确的电话或者手机号");
          // if (!(/^1[34578]\d{9}$/.test(this.formLeft.cliPhone))) return this.$Message.error("请输入正确的电话或者手机号");
          if (!this.formLeft.cliContact)
            return this.$Message.error("联系人不能为空");
          if (!this.formLeft.cliAddress)
            return this.$Message.error("地址不能为空");
          let params = Object.assign(
            {},
            {
              cliNum,
              cliName,
              cliPhone,
              cliContact,
              cliAddress
            }
          );
          let clientId = this.formLeft.clientId;
          if (clientId) {
            let id = clientId;
            api.updateClientById({ ...params, id }).then(res => {
              let data = res.data;
              if (data.code === 0) {
                this.$Message.success("更新成功");
                this.modal3 = false;
                // this.$router.back();
                this.getData();
              } else {
                this.$Message.error(data.msg);
              }
            });
          } else {
            api.newClient({ ...params }).then(res => {
              let data = res.data;
              if (data.code === 0) {
                this.$Message.success("添加成功");
                this.modal3 = false;
                // this.$router.back();
                this.getData();
              } else {
                this.$Message.error(data.msg);
              }
            });
          }
        }
      }
      // // if (!(/^1[34578]\d{9}$/.test(this.formLeft.cliPhone))) return this.$Message.error("请输入正确的电话");
      // if (!(/(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}/.test(this.formLeft.cliPhone))) return this.$Message.error("请输入正确的电话或者手机号");
      // // if (!(/^1[34578]\d{9}$/.test(this.formLeft.cliPhone))) return this.$Message.error("请输入正确的电话或者手机号");
      // if (!this.formLeft.cliContact) return this.$Message.error("联系人不能为空");
      // if (!this.formLeft.cliAddress) return this.$Message.error("地址不能为空");
    },
    cancel() {
      //   this.$Message.info("取消编辑");
    },
    // 复选框选中内容
    changeSelection(selection) {
      this.selectionId = [];
      selection.map(item => {
        this.selectionId.push(item.id);
      });
    },
    //批量删除
    delData(e, id) {
      let ids = [];
      if (id) {
        // 删除一个
        ids.push(id);
      } else {
        // 删除选中的所有
        if (this.selectionId.length > 0) {
          ids = this.selectionId;
        } else {
          this.$Message.error("没有要删除的角色");
        }
      }

      api.deleteClientById(ids).then(res => {
        if (res.data.code === 0) {
          this.$Message.success("删除成功");
          this.getData();
        }
      });
    },
    del() {
      this.modal_loading = true;
      let id = this.data6[this.id].id;
      api.deleteClientById([(this.id = id)]).then(res => {
        if (res.data.code === 0) {
          setTimeout(() => {
            this.modal_loading = false;
            this.modal1 = false;
            this.$Message.success("删除成功");
            this.getData();
          }, 2000);
        } else {
          setTimeout(() => {
            this.modal_loading = false;
            this.modal1 = false;
            this.$Message.success("删除失败");
            this.getData();
          }, 1000);
        }
      });
    },
    remove(index) {
      this.modal1 = true;
      this.id = index;
      this.name = this.data6[index].cliName;
      //   let ids = [];
      //   if (id) {
      //     // 删除一个
      //     ids.push(index);
      //   } else {
      //     // 删除选中的所有
      //     if (this.selectionId.length > 0) {
      //       ids = this.selectionId;
      //     } else {
      //       this.$Message.error("没有要删除的角色");
      //     }
      //   }
    },
    //查询
    query() {},
    //新建显示的页面
    newNustomer() {
      this.modal3 = true;
      this.formLeft.cliNum = "";
      this.formLeft.cliName = "";
      this.formLeft.cliPhone = "";
      this.formLeft.cliContact = "";
      this.formLeft.cliAddress = "";
    },
    // 获取页面数据
    getData() {
      api
        .queryClientList({
          keyword: this.searchCont,
          page: this.page,
          limit: this.limit
        })
        .then(res => {
          let data = res.data;
          if (data.code === 0) {
            this.data6 = data["page"]["list"];
            this.pageTotal = data["page"]["totalCount"];
          } else {
            this.$Message.error(data.msg);
          }
        });
    },
    getData1() {
      api
        .fuzzyQueryClientList({
          keyword: this.searchCont,
          page: this.page,
          limit: this.limit
        })
        .then(res => {
          let data = res.data;
          if (data.code === 0) {
            this.data6 = data["page"]["list"];
            this.pageTotal = data["page"]["totalCount"];
            if(this.data6.length == 0){
              this.$Message.success("搜索不到该租户");
            }else{
              this.$Message.success("搜索成功");
            }
          } else {
            this.$Message.error(data.msg);
          }
        });
    },
    // 高级搜索的数据
    searchMoreData() {
      let _Oparams = {};
      this.searchTermList = this.searchTermList.filter(function(x) {
        return (
          x.searchAttr !== "" && x.searchVal !== "" && x.searchAttr !== "无"
        );
      });
      this.searchTermList.map(item => {
        if (item["searchVal"]) _Oparams[item["searchAttr"]] = item["searchVal"];
      });
      _Oparams["page"] = this.page;
      _Oparams["limit"] = this.limit;
      api.queryClientList(_Oparams).then(res => {
        let data = res.data;
        if (data.code === 0) {
          this.data6 = data["page"]["list"];
          this.pageTotal = data["page"]["totalCount"];
        } else {
          this.$Message.error(data.msg);
        }
      });
    },
    // 复选框选中内容
    changeSelection(selection) {
      this.selectionId = [];
      selection.map(item => {
        this.selectionId.push(item.id);
      });
    },
    // 删除

    // 搜索
    searchHandler() {
      this.selectionId = [];
      this.page = 1;
      this.getData1();
      this.isSearchMore = false;
    },
    // 高级搜索
    searchMoreHandler() {
      this.showMoreSearch = !this.showMoreSearch;
    },
    // 添加搜索条件
    addTermList_clickHandler() {
      this.searchTermList.push({ searchAttr: "", searchVal: "" });
    },
    // 搜索确定
    searchMoreData_clickHandler() {
      this.selectionId = [];
      this.page = 1;
      this.searchMoreData();
      this.showMoreSearch = false;
      this.isSearchMore = true;
    },
    toBuild() {
      this.$router.push({ path: "new-client" });
    },
    changePage(val) {
      this.page = val;
    }
  },
  created() {
    this.getData();
    // this.showNew = api.getRoleAuth(this.$store.state.user, 4021);
    // this.showDelInfo = api.getRoleAuth(this.$store.state.user, 4022);
  },
  watch: {
    page: {
      handler() {
        if (this.isSearchMore) {
          this.searchMoreData();
        } else {
          this.getData();
        }
      },
      deep: true
    }
  }
};
</script>
